module.exports = __webpack_public_path__ + "img/introduce-icon1.281739bf.svg";